<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-three">
<h1>Chapter Three</h1>
<p>The mere thought of her forthcoming birthday sent shivers of dread through Margaret Rainforth’s aged body. On 1<sup>st</sup> December, she would reach the grand old age of ninety-five, and there was absolutely nothing she could do about it. If only, she mused, she could sweep back the tides of time; if only the sands of time were not rushing uncontrollably through the hourglass, if only she had taken a different course in her life.</p>
<p>She sat in her usual place at the usual time, watching the same scenario unravel before her aged eyes, and yet, each morning, aspects of the scene were creatively reconstructed. The same actors performing variations of the ritualistic scene; different lines of speech interspersed with laughter, shouts, yelps, and the occasional scuffle added to the mix. This, concluded Margaret, was the best part of the day. Half an hour or so later, it was gone, until the next morning and the next and the next until, one morning, she would no longer sit at the window. That day, she knew in her heart of hearts, was not far off; she could feel, sense, and smell its coming. Soon, it would be here; soon, but it was not quite here yet.</p>
<p>About to let the flimsy, grey-tinged curtain drop, something, someone—caught her attention. Her old, sharp eyes focused on one figure as it passed her window. Slowly and alone, the girl passed, as a pair of surreptitious eyes followed her every move and a collection of questions gathered in the old lady’s head. Who was this girl? Why was she alone? Was she clever, ambitious, or was she a dreamer? Was she reaching for the stars or merely settling for crumbs? Was she happy? Was she loved?</p>
<p>Margaret closed her eyes on the last thought.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?906e4694